// extracted by mini-css-extract-plugin
export default {"background-$(backgroundColorBg)":"a3Jtu","background-$(backgroundColor)":"b3Jtu","responsiveBackground":"c3Jtu","borderRadius":"d3Jtu"};